module.exports = __webpack_public_path__ + "img/Strip-Front-B1-Jc.b890f007.png";